import React, { useState, useMemo } from 'react';
import WeatherData from '../../../core/WeatherData';
import { ResponsiveContainer, Area, YAxis, XAxis, Tooltip, AreaChart } from 'recharts';

interface RiverChart {
    weatherData: WeatherData
}

const RiverChartComponent: React.FC<RiverChart> = ({ weatherData }) => {
    const levels = weatherData.getRiverLevels();
    console.log(levels);    
    
    const formatTick = useMemo(() => {
        return (index: number) => {
            const d = levels[index].getDate();
            const prefix = `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
            return `${prefix} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
        };
    }, [levels]);

    const chartData = levels.map((l, i) => { return { date: levels[i].getDate(), x: formatTick(i), level: l.getLevel() }; });

    return (
        <ResponsiveContainer width="100%" height={152}>
            <AreaChart data={chartData} margin={{top: 5, bottom: 5}}>
                <XAxis dataKey="x" tick={{fontSize: 10 }} angle={-30} textAnchor='end' tickFormatter={(value: string) => value.substring(5)}/>
                <YAxis tick={{fontSize: 12 }} domain={[dataMin => (dataMin - (dataMin * 0.03)), 'dataMax']} interval={'preserveStartEnd'} tickFormatter={(value) => `${value.toFixed(2)} m`} />
                <Tooltip formatter={(value: number) => [`${value} m`, 'Rio']} cursor={{ fill: 'transparent' }} />
                <Area dataKey="level" type='monotone' fill={'hsl(229, 53%, 53%)'} stroke={'hsl(229, 53%, 53%)'} />
            </AreaChart>
        </ResponsiveContainer>
    )
}

export default RiverChartComponent;
